var map = {
	"./10C.svg": "a36b",
	"./10D.svg": "cfec",
	"./10H.svg": "a00f",
	"./10S.svg": "b9b5",
	"./2C.svg": "9486",
	"./2D.svg": "f868",
	"./2H.svg": "7730",
	"./2S.svg": "f6e7",
	"./3C.svg": "dd29",
	"./3D.svg": "fd1d",
	"./3H.svg": "210a",
	"./3S.svg": "0b5c",
	"./4C.svg": "a2d2",
	"./4D.svg": "39ea",
	"./4H.svg": "9484",
	"./4S.svg": "f2c3",
	"./5C.svg": "4957",
	"./5D.svg": "ed36",
	"./5H.svg": "cdb7",
	"./5S.svg": "ff7f",
	"./6C.svg": "642c",
	"./6D.svg": "9f6d",
	"./6H.svg": "a8fb",
	"./6S.svg": "5394",
	"./7C.svg": "36bf",
	"./7D.svg": "24ec",
	"./7H.svg": "6eb9",
	"./7S.svg": "6c60",
	"./8C.svg": "0b87",
	"./8D.svg": "fdb5",
	"./8H.svg": "7067",
	"./8S.svg": "bcab",
	"./9C.svg": "6516",
	"./9D.svg": "6405",
	"./9H.svg": "a12d",
	"./9S.svg": "4128",
	"./AC.svg": "8e8a",
	"./AH.svg": "192e",
	"./AS.svg": "bdb0",
	"./AceD.svg": "a949",
	"./BLUE_BACK.svg": "7ccc",
	"./C.svg": "1798",
	"./D.svg": "e68d",
	"./H.svg": "954f",
	"./JC.svg": "1c58",
	"./JD.svg": "2c2b",
	"./JH.svg": "0272",
	"./JS.svg": "5b3b",
	"./KC.svg": "8a89",
	"./KD.svg": "6bbb",
	"./KH.svg": "7d38",
	"./KS.svg": "3cc2",
	"./QC.svg": "4209",
	"./QD.svg": "e031",
	"./QH.svg": "985e",
	"./QS.svg": "6ed5",
	"./RED_BACK.svg": "5635",
	"./S.svg": "8c37",
	"./TC.svg": "2ec0",
	"./TD.svg": "8f22",
	"./TH.svg": "9914",
	"./TS.svg": "819c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc34";